import { useEffect, useState, useRef } from "react";

export default function useUserScrolled() {
  const [scrolled, setScrolled] = useState(false);
  const lastScroll = useRef(0);
  const locked = useRef(false); // ensures one-time update

  useEffect(() => {
    if (locked.current) return;

    const detect = () => {
      if (locked.current) return;

      const y = window.scrollY || window.pageYOffset;
      if (y !== lastScroll.current) {
        locked.current = true;
        setScrolled(true);
      }

      lastScroll.current = y;
    };

    const events = ["scroll", "wheel", "touchmove", "pointermove"];
    events.forEach((ev) =>
      window.addEventListener(ev, detect, { passive: true })
    );

    window.addEventListener("keydown", (e) => {
      const keys = ["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Space"];
      if (keys.includes(e.code)) {
        locked.current = true;
        setScrolled(true);
      }
    });

    return () => {
      events.forEach((ev) =>
        window.removeEventListener(ev, detect)
      );
    };
  }, []);

  return scrolled;
}
